import {RefObject, useEffect} from 'react';

import {SourcingTableDispatch} from '../../../store/sourcingTable/reducer';

const SCROLL_THRESHOLD_PX = 560;

type InfiniteScrollListenerProps = {
  scrollContainerRef: RefObject<HTMLDivElement | null>;
  dispatch: SourcingTableDispatch;
  isFetching: boolean;
  isEnabled: boolean;
  nextPage: number;
};

export function InfiniteScrollListener({
  scrollContainerRef,
  dispatch,
  isFetching,
  isEnabled,
  nextPage,
}: InfiniteScrollListenerProps) {
  useEffect(
    function attachInfiniteScrollListener() {
      const scrollContainer = scrollContainerRef.current;
      if (!scrollContainer || !isEnabled) {
        return;
      }

      function handleScroll() {
        const container = scrollContainerRef.current;
        if (!container || isFetching || !isEnabled) {
          return;
        }

        const distanceFromBottom =
          container.scrollHeight - container.scrollTop - container.clientHeight;

        if (distanceFromBottom < SCROLL_THRESHOLD_PX) {
          dispatch({type: 'changePage', page: nextPage});
        }
      }

      scrollContainer.addEventListener('scroll', handleScroll, {passive: true});
      handleScroll();

      return () => {
        scrollContainer.removeEventListener('scroll', handleScroll);
      };
    },
    [scrollContainerRef, dispatch, isFetching, isEnabled, nextPage]
  );

  return null;
}
